import styled from 'styled-components';

import { Tooltip } from '@frontend/components';

const Wrapper = styled.div`
  background: rgba(0, 0, 0, 0);
  border: 2px solid #ddd;
  bottom: 150px;
  display: flex;
  flex-direction: column;
  left: 10px;
  padding-bottom: 10px;
  position: absolute;
  z-index: 2;
`;

const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 10px 0 0 0;
  padding: 0 10px;
  width: 100%;
`;

const Title = styled.span`
  font-size: 12px;
  font-weight: 600;
`;

const Column = styled.div`
  width: 80px;

  :first-of-type {
    margin-right: 10px;
  }
`;

const LegendEntry = styled.div`
  align-items: center;
  display: flex;
`;

const LegendEntryColor = styled.div`
  border: 1px solid #6d6d6d;
  height: 10px;
  margin: 0 5px 1px 0;
  width: 20px;

  ${(props) => `background: ${props.color};`};
`;

const LegendEntryLabel = styled.span`
  font-size: 10px;
`;

const BarStockLegend = () => (
  <Wrapper>
    <RowContainer>
      <Title>Stock Legend</Title>
    </RowContainer>
    <RowContainer>
      <Column>
        <Tooltip placement="top" label="Material the machine will cut">
          <LegendEntry>
            <LegendEntryColor color="#6DF377" />
            <LegendEntryLabel>Workpiece</LegendEntryLabel>
          </LegendEntry>
        </Tooltip>
      </Column>
      <Column>
        <Tooltip placement="top" label="Material lost from prep cutting">
          <LegendEntry>
            <LegendEntryColor color="#FC8875" />
            <LegendEntryLabel>Sacrificial</LegendEntryLabel>
          </LegendEntry>
        </Tooltip>
      </Column>
    </RowContainer>
    <RowContainer>
      <Column>
        <Tooltip
          placement="top"
          label="Unused material at the end of the stock"
        >
          <LegendEntry>
            <LegendEntryColor color="#9196F5" />
            <LegendEntryLabel>Unused</LegendEntryLabel>
          </LegendEntry>
        </Tooltip>
      </Column>
      <Column>
        <Tooltip
          placement="top"
          label="Unused material needed to hold the stock in the machine"
        >
          <LegendEntry>
            <LegendEntryColor color="#8AF9F0" />
            <LegendEntryLabel>Bar End</LegendEntryLabel>
          </LegendEntry>
        </Tooltip>
      </Column>
    </RowContainer>
  </Wrapper>
);

export default BarStockLegend;
